import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
	state: {
		menuOpen: false,
		connectionError: false,
		yarnsArchive: [],
	},
	mutations: {
		openMenu(state, menuOpen) {
			state.menuOpen = menuOpen;
		},
		updateYarnsArchive(state, yarnsArchive) {
			state.yarnsArchive = yarnsArchive;
		},
		setConnectionError(state, connectionError) {
			state.connectionError = connectionError;
		},
	},
	actions: {
		openMenu({commit}) {
			commit('openMenu', true);
		},
		closeMenu({commit}) {
			commit('openMenu', false);
		},
		async updateYarnsArchive ({commit, getters}) {
			const yarns = [].concat(... await Promise.all([
				new Promise(async resolve => {
					try {
						let localYarns = await Vue.storage.getItem('yarns-archive') || [];
						localYarns = localYarns.map(o => {
							o.saved = "local";
							if(!o.timestamp) {
								o.timestamp = new Date(null);
							} else {
								o.timestamp = new Date(o.timestamp);
							}
							return o;
						})
						resolve(localYarns);
					} catch(error) {
						console.error(error);
						resolve([]);
					}
				}),
				new Promise(async resolve => {
					try {
						let dbYarns = [];
						if(getters.isAuthenticated){
							const response = await axios.get('/yarns');
							dbYarns = response.data.response.map(o => {
								const yarn = JSON.parse(o.data);
								return { data: yarn.data, result: yarn.result, saved: "cloud", id: o.id, timestamp: new Date(o.timestamp)};
							}) || [];
						}
						resolve(dbYarns);
					} catch(error) {
						console.error(error);
						resolve([]);
					}
				})
			]));
/* 			return await Vue.storage.getItem('yarns-archive').then(async (result) => {
				try {
					const yarns = await new Promise((resolve, reject) => {
						axios.get('/yarns')
						.then(response => {
							let rows = response.data.response;
							const resultData = rows.map(row => {
								return JSON.parse(row.data);
							});
							resolve(resultData);
						})
						.catch(error => {
							reject(error);
						});
					});
					const yarnsArrayLength = result.length;
					yarns.forEach((yarn, index) => {
						result.push({id: yarnsArrayLength + index, data: yarn.data, result: yarn.result})
					});
				} catch (error) {

				} */
			commit('updateYarnsArchive', yarns);
			return yarns;
		},
		setConnectionError({commit}, {connectionError}) {
			return new Promise((resolve, reject) => {
				commit('setConnectionError', connectionError);
				if (connectionError) {
					// eslint-disable-next-line
					// console.log('Session expired, must log again');
				}
				resolve();
			});
		},
	}, getters: {
		isMenuOpen: state => state.menuOpen,
		getYarnsArchive: state => state.yarnsArchive,
		isConnectionError: state => state.connectionError,
	},
}
